import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import { Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";

import Header from "./components/Header/Header.jsx";
import Footer from "./components/Footer/Footer.jsx";

import Home from "./components/Home/Home.jsx";
import AboutUs from "./components/About-Us/AboutUs.jsx";
import Gallery from "./components/Gallery/Gallery.jsx";
import ArtistsList from "./components/ArtistsList/ArtistsList.jsx";
import ArtistProfile from "./components/ArtistProfile.jsx";
import SignUp from "./components/SignUp/SignUp.jsx";
import LoginForm from "./components/LogIn/LogIn.jsx";
import Events from "./components/Events/Events.jsx";
import TheArtEvents from "./components/ArtEvents/TheArtEvents.jsx";
import Landing from "./components/Header/Landing.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import Chat from "./components/Chat/Chat.jsx";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword.jsx";
import ResetPassword from "./components/ResetPassword/ResetPassword.jsx";
import EditProfile from "./components/EditProfile/EditProfile.jsx";
import MediaPress from "./components/MediaPress/MediaPress.jsx";
import Forum from "./components/Forum/Forum.jsx";
import ForumCategory from "./components/Forum/ForumCategory.jsx";
import ForumThread from "./components/Forum/ForumThread.jsx";
import ForumRegister from "./components/Forum/ForumRegister.jsx";
import ForumBookshelf from "./components/Forum/ForumBookshelf.jsx";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Header />

        <main style={{ minHeight: "60vh", paddingTop: "118px" }}>
          <Routes>
            {/* Root → Home */}
            <Route path="/" element={<Navigate to="/Home" replace />} />

            <Route path="/Home" element={<Home />} />
            <Route path="/About-us" element={<AboutUs />} />
            <Route path="/About-Us" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/ArtistsList" element={<ArtistsList />} />
            <Route path="/artistsList" element={<ArtistsList />} />
            <Route path="/Events" element={<Events />} />
            <Route path="/ArtEvents" element={<TheArtEvents />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/login" element={<LoginForm />} />
            <Route path="/LogIn" element={<LoginForm />} />
            <Route path="/Landing" element={<Landing />} />
            <Route path="/ArtistProfile/:id" element={<ArtistProfile />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/Chat" element={<Chat />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/edit-profile/:id" element={<EditProfile />} />
            <Route path="/media" element={<MediaPress />} />

            {/* Forum */}
            <Route path="/Forum"                       element={<Forum />} />
            <Route path="/forum"                       element={<Forum />} />
            <Route path="/Forum/category/:slug"        element={<ForumCategory />} />
            <Route path="/Forum/thread/:id"            element={<ForumThread />} />
            <Route path="/Forum/register"              element={<ForumRegister />} />
            <Route path="/Forum/bookshelf"             element={<ForumBookshelf collection="bookshelf" />} />
            <Route path="/Forum/audio"                 element={<ForumBookshelf collection="audio" />} />
            <Route path="/Forum/documents"             element={<ForumBookshelf collection="documents" />} />
            <Route path="/Forum/archive"               element={<ForumBookshelf collection="archive" />} />

            {/* Catch-all → Home */}
            <Route path="*" element={<Navigate to="/Home" replace />} />
          </Routes>
        </main>

        <Footer />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
